import { Box, Typography, Button } from '@mui/material';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';

const Container = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    textAlign: 'center',
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(4),
}));

const Title = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
    color: theme.palette.error.main,
    marginBottom: theme.spacing(2),
}));

const Message = styled(Typography)(({ theme }) => ({
    fontSize: theme.typography.size.lg,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(4),
}));

const StyledButton = styled(Button)(({ theme }) => ({
    margin: theme.spacing(2, 2, 0, 2),
    padding: theme.spacing(1, 3),
    fontSize: theme.typography.size.base,
}));

const NotFound = () => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    };

    const handleHome = () => {
        navigate('/');
    };

    return (
        <Container>
            <Title variant="h1">404</Title>
            <Message>Sorry, The resource you're looking for doesn't seem to exist.</Message>
            <Box>
                <StyledButton variant="contained" color="primary" onClick={handleHome}>
                    Go to Homepage
                </StyledButton>
                <StyledButton variant="outlined" color="secondary" onClick={handleGoBack}>
                    Go Back
                </StyledButton>
            </Box>
        </Container>
    );
};

export default NotFound;
